import { getDocument } from '@atlaskit/browser-apis';
import { Spotlight, SpotlightPulse, SpotlightTransition } from '@atlaskit/onboarding';
import { useMessageInstanceEvent } from '@post-office/message-instance-event-frontend-client';
// @ts-expect-error: 'React' is declared but its value is never read
// React import required to render in Jira SSR
import React, { type PropsWithChildren, useCallback, useEffect, useState } from 'react';
import { useIntl } from 'react-intl-next';

import { spotlightMessages } from './messages';
import { token } from '@atlaskit/tokens';

export const ExportIssuesFlyoutSpotlight = ({ children }: PropsWithChildren) => {
	const [isActive, setIsActive] = useState(true);

	const { messageInstanceClicked } = useMessageInstanceEvent();
	const { formatMessage } = useIntl();

	const handleRead = useCallback(() => {
		setIsActive(false);
		void messageInstanceClicked({
			action: {
				actionType: 'read',
			},
			additionalMetadataFromFrontend: {},
			clickedElement: {
				buttonType: 'primary',
				clickedElement: 'button',
				clickIdentifier: 'okButton',
			},
			messageEventType: 'clicked',
		});
	}, [messageInstanceClicked]);

	useEffect(() => {
		const handleEscape = (ev: KeyboardEvent) => {
			if (ev.key === 'Escape') {
				handleRead();
			}
		};

		getDocument()?.addEventListener('keydown', handleEscape);

		return () => {
			getDocument()?.removeEventListener('keydown', handleEscape);
		};
	}, [handleRead]);

	return (
		<>
			<SpotlightPulse radius={3} pulse={isActive}>
				{children}
			</SpotlightPulse>
			{isActive && (
				<SpotlightTransition>
					<Spotlight
						actions={[
							{
								onClick: handleRead,
								text: formatMessage(spotlightMessages.spotlightOkButton),
								appearance: 'default',
							},
						]}
						heading={formatMessage(spotlightMessages.spotlightHeading)}
						target="nin.page-actions.meatball-menu-popup-exports"
						key="nin.page-actions.meatball-menu-popup-exports"
						targetRadius={3}
						dialogWidth={270}
						targetBgColor={token('elevation.surface')}
						pulse={true}
						testId="export-issues-flyout-spotlight"
						dialogPlacement="left top"
					>
						{formatMessage(spotlightMessages.spotlightBody)}
					</Spotlight>
				</SpotlightTransition>
			)}
		</>
	);
};

export default ExportIssuesFlyoutSpotlight;
